import { User } from '../../shared/models/User';
import { MediaObject } from './MediaObject.model';
import { Course } from './Course.model';
import { RoadBook } from './RoadBook.model';
import { Tag } from '../../../@core/models/tag.model';

export class Presential extends Course {
    public authors: User[];
    public coursePrerequisites: string;
    public createdBy: User;
    public currency: string;
    public dateCreated: string;
    public dateModified: string;
    public description: string;
    public duration: string;
    public educationalCredentialAwarded: string;
    public iri: string;
    public isNotified: boolean;
    public language: string;
    public maxTraineeCapacity: number;
    public media: MediaObject;
    public openForAll: boolean;
    public price: number;
    public roadBook: RoadBook;
    public videoPath: string;
    public tagIds?: number[];
    public tags?: Tag[];
    constructor(json?) {
        super(json);
        if (json) {
            this.iri = json['@id'];
            this.educationalCredentialAwarded = json.educationalCredentialAwarded;
            this.duration = json.duration;
            this.description = json.description;
            this.coursePrerequisites = json.coursePrerequisites;
            this.language = json.language;
            this.maxTraineeCapacity = json.maxTraineeCapacity;
            this.media = json.media;
            this.authors = json.authors;
            this.price = json.price;
            this.roadBook = json.roadBook;
            this.isNotified = json.isNotified;
            this.currency = json.currency;
            this.createdBy = json.createdBy;
            this.dateCreated = json.dateCreated;
            this.dateModified = json.dateModified;
            this.openForAll = json.openForAll;
        }
    }
}
